import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TUserRolesApi } from './types';

export const userRoles: TUserRolesApi = {
	getRoles: () => http.get(endpoint.userRoles.GET_ROLES).then(response => response.data),
	getGrouped: payload =>
		http.post(endpoint.userRoles.GET_GROUPED, payload).then(response => response.data),
	getUserRoles: payload =>
		http.post(endpoint.userRoles.GET_USER_ROLES, payload).then(response => response.data),
	getUserRolesByUserId: payload =>
		http
			.get(endpoint.userRoles.GET_USER_ROLES_BY_USER_ID(payload.userId))
			.then(response => response.data),
	assignRoles: payload => http.post(endpoint.userRoles.ASSIGN_ROLES, payload),
	updateUserRole: payload => http.put(endpoint.userRoles.UPDATE_USER_ROLE, payload),
	removeUserRole: payload => http.delete(endpoint.userRoles.REMOVE_USER_ROLE(payload.id)),
};
